export default __webpack_public_path__ + "static/media/Video.c21a7e52.svg";